import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL } from '@images/imageUrls';
import classNames from 'classnames';

interface PCCommonSharePopupProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    // 是否显示
    visible: boolean;
    // 显示隐藏
    shareClose?: Function
    // 标题
    title?: string;
    // 取消事件
    onCancelChange?: Function
    // 取消按钮文字
    cancelText?: string
    // 插槽相关属性
    children?: React.ReactNode; // 内容插槽
    mode?: any  // 模式（黑色或白色,默认白色）
    copyText?: any  // 要复制的文本
    copyLink?: Function // 复制链接方法
    onDrawCanvas?: Function // 保存图片方法
    isShowCopy?: any    // 是否显示复制链接
    isShowSavePoster?: any    // 是否显示保存图片
}

@inject('app', 'site', 'user')
@observer
class PCCommonSharePopup extends React.Component<PCCommonSharePopupProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }
    // 隐藏
    onHidePopup = () => {
        this.props.onCancelChange && this.props.onCancelChange()
    }

    render() {
        let {  visible, title,   cancelText = '取消', children } = this.props
        return <>
            <div className={classNames(styles.popupBox, visible ? styles.openPopup : '')}>
                <div className={classNames(styles.popupMask)} onClick={this.onHidePopup}></div>
                
            </div>
        </>;
        
    }
}

export default PCCommonSharePopup;